module.exports = __webpack_public_path__ + "img/flag_ua.e8e24308.svg";